import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-distict-grid',
  templateUrl: './distict-grid.component.html',
  styleUrls: ['./distict-grid.component.css']
})
export class DistictGridComponent implements OnInit {
  title="District List (Active)";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/master/district/distict-grid/distict-grid.component.ts